import { useMutation } from 'react-query';
import { login } from '../infrastructure/login';

export const useLoginMutation = () => {
    return useMutation({
        mutationFn: login,
    });
};
